import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";

import { DeleteDialog, ShipmentToolbar } from "./components";
import mockData from "./data";
import EditShipmentReq from './../ListRequest/components/EditShipmentReq/EditShipment'
import ListRequestTable from "./components/ListRequestTable";
import theme from "theme";
import { useMediaQuery } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  rootSmall: {
    padding: 0,
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

const ListRequest = () => {
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));

  const [reloadPage, setReloadpage] = useState(false);
  function reloadFunction() {
    setReloadpage(!reloadPage);
  }

  const [data] = useState(mockData);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const toggleDeleteDialog = () => {
    setShowDeleteDialog(!showDeleteDialog);
  };

  const [showEditDialog, setEditInfoDialog] = useState(false);
  const toggleEditDialog = () => setEditInfoDialog(!showEditDialog);

  const [idSel, setIdSelDialog] = useState("0");
  const [DataInfo, setDataInfo] = useState(
    {data: {
           id:'',
          date: "",
          origin: "",
          dest: "",
          type_shipment: "",
          type_car: "",
          tonnage: "",
          desc: "",
          name: "",
          phone: ""

          }
     })
  function handleIdChange(newId,newDate,newOrigin,newDest,newTypeS,newTypeC,newTonnage,newDesc,newName,newCall) {
    setDataInfo({...DataInfo,  data: {
      id:newId,
          date: newDate,
          origin: newOrigin,
          dest: newDest,
          type_shipment: newTypeS,
          type_car: newTypeC,
          tonnage: newTonnage,
          desc: newDesc,
          name: newName,
          phone: newCall
      },
 })
    // setIdSelDialog(newId);
    
  }

  const [DataSel, setDataSel] = useState([]);

  function SelectData(newData) {
    setDataSel(newData);
  }

  return (
    <div className={isSmall?classes.rootSmall: classes.root}>

      {/* delete Request */}
      {/* {showDeleteDialog ? (
        <DeleteDialog
          id={idSel}
          reloadFunc={reloadFunction}
          type="Employee"
          onClose={toggleDeleteDialog}
          open={showDeleteDialog}
          title="حذف بارنامه"
          desc={DataSel}
        />
      ) : (
        ""
      )} */}

   
   {/* Edit Request */}
      {showEditDialog ? (
        <EditShipmentReq
          onAccept={toggleEditDialog}
          onClose={toggleEditDialog}
          data={data || undefined}
          id={DataInfo}
          
          reloadFunc={reloadFunction}
          title="اطلاعات بیشتر"
          open={showEditDialog}
        />
      ) : (
        ""
      )}

      {/* <ShipmentToolbar  /> */}
      <div className={classes.content}>
        <ListRequestTable
          ChangeId={handleIdChange}
          showEdit={toggleEditDialog}
          onDelete={toggleDeleteDialog}
          data={data}
          selData={SelectData}
          reload={reloadPage}
          reloadFunc={reloadFunction}
          edit={showEditDialog}
          del={showDeleteDialog}
        />
      </div>
    </div>
  );
};

export default ListRequest;
